export default "__VITE_ASSET__2be17825__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg6__"